import '../style/main.css';
import Meta from '../components/Meta.js';
import Header from '../components/Header.js';
import Footer from '../components/Footer.js';
import Slideshow from '../components/Slideshow.js';
function Gallery() {
  return (
		<>
			<Meta title='Gallery' />
			<Header />
			<div class='main-content'>
				<h2>Gallery</h2>
				<Slideshow />
			</div>
			<Footer />  
		</>
	);
};

export default Gallery;
